import { z } from "zod";

export const eventFormSchema = z
  .object({
    title: z.string().min(1, "Title is required"),
    description: z.string().optional(),
    source: z.enum(["manual", "meta", "clayrio"]),
    channel: z.enum(["ecommerce", "retail", "wholesale"], { required_error: "Channel is required" }),
    startAt: z.string().min(1, "Start date is required"),
    endAt: z.string().min(1, "End date is required"),
    location: z.string().optional(),
  })
  .refine(
    (data) => {
      if (data.channel === "retail") {
        return typeof data.location === "string" && data.location.trim().length > 0;
      }
      return true;
    },
    { message: "Location is required for retail events", path: ["location"] }
  );